import {Component, Input, OnInit} from '@angular/core';
import {Field} from 'shared';

@Component({
  selector: 'app-map-field-popup',
  templateUrl: './map-field-popup.component.html',
  styleUrls: ['./map-field-popup.component.scss']
})
export class MapFieldPopupComponent implements OnInit {

  @Input()
  field: Field;

  constructor() {
  }

  ngOnInit(): void {
  }

}
